import { useMemo } from 'react';
import setRef from '@asherng/utils/setRef';
import type { UseForkRef } from './types';

const useForkRef: UseForkRef = (refA, refB) =>
  useMemo(() => {
    if (refA == null && refB == null) {
      return null;
    }

    return refValue => {
      setRef(refA, refValue);

      setRef(refB, refValue);
    };
  }, [refA, refB]);

export default useForkRef;
